import React from 'react';
import './App.scss';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/home';
import Contact from './pages/contact';
import BackToTop from './components/backToTop/backToTop';
import ErrorBoundary from './components/errorBoundary/errorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <div className="app">
          <Routes>
            <Route path="/" element={ <Home /> } />
            <Route path="/contactenos" element={ <Contact /> } />
          </Routes>
          <BackToTop />
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
